/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_TitleInputs */

const en_cap_title = /** @type {(inputs: Cap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we build`)
};

const lv_cap_title = /** @type {(inputs: Cap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko mēs veidojam`)
};

/**
* | output |
* | --- |
* | "What we build" |
*
* @param {Cap_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_title = /** @type {((inputs?: Cap_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_title(inputs)
	return en_cap_title(inputs)
});